import React, { Component } from "react";
import { connect } from 'react-redux';
import { Field, reduxForm, reset } from 'redux-form'
import { Form, FormGroup, ModalHeader, ModalBody, ModalFooter, Row, Col, Button, Label } from 'reactstrap';
import { toast } from 'react-toastify';
import { fetchCalculationParameterRequest } from './action'

const required = value => value ? null : 'Required';
const isValid = value => !value || value.match(/^[^<>!$%^?*~`{}=]*$/) ? null : 'Please enter valid Input';

const renderField = ({ input, label, type, isRequired, disabled, meta: { touched, error, warning } }) => (
    <Row className="mb-3 align-items-center">
        <Col sm="9">
            <label className="mb-0">{label}</label>
            {(isRequired && <span className="text-danger">*</span>)}
        </Col>
        <Col sm="15">
            <input {...input} placeholder={label} disabled={disabled} type={type} className="form-control" />
            {touched &&
                ((error && <span className="text-danger">{error}</span>) ||
                    (warning && <span className="text-warning">{warning}</span>))}
        </Col>
    </Row>
)
class AutomatedRevenueForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            initialData: []
        }
    }

    componentDidMount() {
        //this.props.load(this.props.initialValues);
    }

    componentWillUnmount() {
        
    }

    componentDidUpdate(prevProps) {
        if (this.props.initialValues !== prevProps.initialValues) {

        }
    }
    
    submitParameters = (val) => {
        if (val.nicCode === "") {
            toast.error(
                <div>
                    <i className="fa fa-check"></i>&nbsp; Please Enter NIC Code.
                </div>
            );
        }
        else if (val.totalActiveGstReturns === "") {
            toast.error(
                <div>
                    <i className="fa fa-check"></i>&nbsp; Please Enter number of Active GST&#39;s.
                </div>
            );
        }
        else if (val.gstPincode === "") {
            toast.error(
                <div>
                    <i className="fa fa-check"></i>&nbsp; Please Enter Entity Pincode.
                </div>
            );
        } else {
            this.props.createRevenuRequestBody(val);
        }
    }

    render() {
        const { handleSubmit, pristine, submitting, reset } = this.props
        return (
            <Row>
                <form className="modal-content shadow-none border-0" onSubmit={handleSubmit((val) => this.submitParameters(val))}>
                    <ModalHeader>
                        Automated Revenue calulation Parameters
                    </ModalHeader>
                    <ModalBody>
                        <Field
                            name="year"
                            type="text"
                            component={renderField}
                            label="Year"
                            disabled={true}
                            value={new Date().getFullYear() - 1}
                        />
                        <Field
                            name="nicCode"
                            type="text"
                            component={renderField}
                            label="NIC Code"
                        />
                        <Row className="mb-3 align-items-center">
                            <Col sm="9">
                                Constitution
                            </Col>
                            <Col sm="15">
                                <Field name="classOfCompany" component="select" label="Constitution" className="form-control dropdown-counterparty border" validate={[required]}>
                                    <option value=''>Select</option>
                                    <option value='PROPRIETORSHIP'>PROPRIETORSHIP</option>
                                    <option value='PARTNERSHIP'>PARTNERSHIP</option>
                                    <option value='OTHERS'>OTHERS</option>
                                </Field>
                            </Col>
                        </Row>
                        <Row className="mb-3 align-items-center">
                            <Col sm="9">
                                Taxpayer Type
                            </Col>
                            <Col sm="15">
                                <Field name="gstTaxpayerType" component="select" label="Taxpayer Type" className="form-control dropdown-counterparty border" validate={[required]}>
                                    <option value=''>Select</option>
                                    <option value='REGULAR'>REGULAR</option>
                                    <option value='COMPOSITION'>COMPOSITION</option>
                                </Field>
                            </Col>
                        </Row>
                        <Field
                            name="totalActiveGstReturns"
                            type="text"
                            component={renderField}
                            label="Number of Active GST"
                        />
                        <Row className="mb-3 align-items-center">
                            <Col sm="9">
                                GSTR 3B Filing Frequency
                            </Col>
                            <Col sm="15">
                                <Field name="gstFillingFrequency" component="select" label="GSTR 3B Filing Frequency" className="form-control dropdown-counterparty border" validate={[required]}>
                                    <option value=''>Select</option>
                                    <option value='QUARTERLY'>QUARTERLY</option>
                                    <option value='MONTHLY'>MONTHLY</option>
                                </Field>
                            </Col>
                        </Row>
                        <Field
                            name="gstPincode"
                            type="text"
                            component={renderField}
                            label="PINCODE of Entity"
                        />
                        <Row className="mb-3 align-items-center">
                            <Col sm="9">
                                Web Presence
                            </Col>
                            <Col sm="15">
                                <Field name="companyWebsite" component="select" label="Web Presence" className="form-control dropdown-counterparty border" validate={[required]}>
                                    <option value=''>Select</option>
                                    <option value='Yes'>Yes</option>
                                    <option value='No'>No</option>
                                </Field>
                            </Col>
                        </Row>
                        <Row className="mb-3 align-items-center">
                            <Col sm="9">
                                Is Entity has Active EPF Number?
                            </Col>
                            <Col sm="15">
                                <Field name="activePfCount" component="select" label="Is Entity has Active EPF Number?" className="form-control dropdown-counterparty border" validate={[required]}>
                                    <option value=''>Select</option>
                                    <option value='Yes'>Yes</option>
                                    <option value='No'>No</option>
                                </Field>
                            </Col>
                        </Row>
                        <Field
                            name="ageOfCompany"
                            type="text"
                            component={renderField}
                            label="Age of company"
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Row>
                            <Col ><Button color="info" size="lg" className="justify-content-center" onClick={() => this.props.handleSectionEditToggle()} > Cancel </Button></Col>
                            <Col ><Button type="submit" color="info" size="lg" className="justify-content-center" disabled={submitting}>Submit</Button></Col>
                        </Row>
                    </ModalFooter>
                </form>
            </Row>
        )
    }
}

AutomatedRevenueForm = reduxForm({
    form: 'automatedRevenueForm', // a unique identifier for this form
    enableReinitialize: true
})(AutomatedRevenueForm);

AutomatedRevenueForm = connect(
  state => ({
    initialValues: {
      ...state.automatedRevenueData.revenuCalculationParams,
      year: new Date().getFullYear() - 1, // auto fill year here
    }
  }),
  { load: fetchCalculationParameterRequest }
)(AutomatedRevenueForm);

export default AutomatedRevenueForm;
